import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './styles/style.scss';
import { BrowserRouter as Router } from 'react-router-dom';
import AdminUserStore from './models/adminUserStore/AdminUser';

const adminStore = AdminUserStore.create();

ReactDOM.render(
    <Router>
        <App adminStore={adminStore} />
    </Router>,
    document.getElementById('root'),
);

reportWebVitals();
